import type { ReactElement } from 'react';
import { Component as NotFavoriteIcon } from 'icons/icon-ui--heart-empty.svg';
import SkeletonLine from './SkeletonLine';

function RecipeSkeleton(): ReactElement {
  return (
    <div className="c-recipe">
      <div className="c-recipe__container">
        <div className="c-skeleton-square" />
        <div className="c-recipe__content--center">
          <SkeletonLine width={80} />
          <SkeletonLine width={220} />
          <SkeletonLine width={240} />
          <SkeletonLine width={180} />
        </div>
        <div className="c-recipe__content--bottom mt-4">
          <div className="c-recipe__info">
            <SkeletonLine width={140} />
          </div>
        </div>
      </div>

      <button
        disabled
        type="button"
        className="c-button c-favorite c-favorite--skeleton"
      >
        <span>
          <NotFavoriteIcon width="26" />
          Removed from Favorites
        </span>
      </button>
    </div>
  );
}

export default RecipeSkeleton;
